import { AppContext } from "../../../context/context";
import { decryptData, isTokenValid } from '../../../utils/utils';
import { Dispatch, useContext, useEffect, useState } from "react";
import { ls } from "../../../localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import RiseSessionForTeacher from "./RiseSessionForTeacher";
import RiseSessionForStudents from "./RiseSessionForStudents";
import { useSelector } from "react-redux";
import { IAdaptiveSessionInfo, IReducer, IUserReducer } from "../../../interface/interface";
import RiseAssessmentForStudents from "./RiseAssessmentForStudents";
import { useDispatch } from "react-redux";
import { userAction } from "../../../reduxStore";
import { Theme } from '../theme';
import { Loader } from '../Loader';

interface IAPcurrentUser {
    id: string,
    classroom_id?: string,
    isB2C: boolean,
    curriculum_id?: string,
    unit_plan_id?: string,
    grade: number,
    role: string,
    dbToken: string,
    total_lo: number,
    token: string
}

export function RiseSession(props: any) {
    const navigate = useNavigate();
    const dispatch: Dispatch<any> = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const QUERY: string = queryParams.get("query") || '';

    const state: any = useContext(AppContext);
    const userReducer: IUserReducer = useSelector((state: IReducer) => state.userReducer);

    const [sessionInfo, setSessionInfo] = useState<Partial<IAdaptiveSessionInfo>>({});
    // Theme chosen in student/teacher web settings, carried in the encrypted payload.
    const [theme, setTheme] = useState<Theme | undefined>(undefined);
    const [isLoader, setIsLoader] = useState(false);
    const currentUser = userReducer.currentUser;
    let lang = 'en';

    useEffect(() => {
        verifyAndSetData();
    }, [])

    const verifyAndSetData = async () => {
        try {
            setIsLoader(true);
            // console.log(QUERY);
            let query: {
                currentUser: IAPcurrentUser,
                sessionInfo: IAdaptiveSessionInfo
                lang: string
                theme?: Theme
            } = decryptData(QUERY);
            setTheme(query.theme);

            // console.log(query);
            // console.log(isTokenValid(query.currentUser.token));

            if (ls.isValid(query) &&
                ls.isValid(query.currentUser) &&
                ls.isValid(query.sessionInfo) &&
                ls.isValid(query.sessionInfo.sessionId) &&
                ls.isValid(query.sessionInfo.adaptiveId) &&
                query.sessionInfo.isLiveMode !== undefined &&
                ls.isValid(query.lang)
                && isTokenValid(query.currentUser.token)
            ) {
                // console.log("setLS")

                if (userReducer.currentUser &&
                    userReducer.currentUser.id &&
                    userReducer.currentUser.id !== query.currentUser.id)
                    dispatch(userAction.setInitialState()); //Intialize if User is not the same 

                ls.setToken(query.currentUser.token);
                ls.setDBToken(query.currentUser.dbToken);

                dispatch(userAction.setCurrentUser(query.currentUser));
                setSessionInfo(query.sessionInfo);
                lang = query.lang;
            }
            else {
                console.log("error while setting local storage");
                state.messageForParent('close');
                navigate('/pageNotFound');
            }

            setIsLoader(false);
        } catch (error) {
            console.log(error);
            state.messageForParent('close');
            navigate('/pageNotFound');
        }
    }


    return (<>
        {(isLoader) && (
            <Loader />
        )}

        {/* Conditional rendering for SESSION */}
        {(currentUser.role === 'student' && sessionInfo.sessionId && sessionInfo.qualifier !== 'ASSESSMENT') && (
            <RiseSessionForStudents {...props} currentUser={currentUser} sessionInfo={sessionInfo} lang={lang} theme={theme} />
        )}
        {/* Conditional rendering for ASSESSMENT */}
        {(currentUser.role === 'student' && sessionInfo.sessionId && sessionInfo.qualifier === 'ASSESSMENT') && (
            <RiseAssessmentForStudents {...props} currentUser={currentUser} sessionInfo={sessionInfo} lang={lang} theme={theme} />
        )}

        {/* Conditional rendering for TEACHER */}
        {(currentUser.role === 'teacher' && sessionInfo.sessionId) && (
            <RiseSessionForTeacher {...props} currentUser={currentUser} sessionInfo={sessionInfo} lang={lang} theme={theme} />
        )}
    </>)
}